const types = {
  HIDE_BATCH_ACTIONS: 'HIDE_BATCH_ACTIONS',
  SET_BATCH_ITEMS_IDS: 'SET_BATCH_ITEMS_IDS',
  SHOW_BATCH_ACTIONS: 'SHOW_BATCH_ACTIONS',
  UPDATE_BATCH_ACTIONS: 'UPDATE_BATCH_ACTIONS',
}

export default types
